import React from 'react';
import reduce from 'lodash/reduce';

import FacebookLoginButton from './FacebookLoginButton';
import AppleLoginButton from './AppleLoginButton';
import GoogleLoginButton from './GoogleLoginButton';
import {
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE,
} from './constants';

import './SocialLogin.scss';

export const SOCIAL_MAP = {
    [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]: FacebookLoginButton,
    [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE]: AppleLoginButton,
    [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_GOOGLE]: GoogleLoginButton,
};

const SocialLoginButtons = ({
    isCheckoutAuthenticationFlow,
    onSocialConnectVerified,
    onSocialConnectNotAuthorized,
    onSocialLogInUserAuthorized,
    handleOnLoadComplete,
    handleOnComponentUpdated,
    handleSocialProviderClick,
    onNotConnected,
    socialSSOSettings = {},
    buttonAppleText,
    buttonFBText,
    buttonGoogleText,
    asyncStrategy,
}) =>
    reduce(
        SOCIAL_MAP,
        (memo, SocialLoginButton, socialProvider) => {
            const settings = socialSSOSettings[socialProvider];

            if (settings) {
                const component = (
                    <div key={socialProvider} className="eds-l-mar-bot-2">
                        <SocialLoginButton
                            isCheckoutAuthenticationFlow={
                                isCheckoutAuthenticationFlow
                            }
                            onSocialConnectVerified={onSocialConnectVerified.bind(
                                null,
                                socialProvider,
                            )}
                            onSocialConnectNotAuthorized={onSocialConnectNotAuthorized.bind(
                                null,
                                socialProvider,
                            )}
                            onSocialLogInUserAuthorized={onSocialLogInUserAuthorized.bind(
                                null,
                                socialProvider,
                            )}
                            handleOnLoadComplete={handleOnLoadComplete}
                            handleOnComponentUpdated={handleOnComponentUpdated}
                            handleOnNotConnected={onNotConnected}
                            onClick={handleSocialProviderClick.bind(
                                null,
                                socialProvider,
                            )}
                            buttonAppleText={buttonAppleText}
                            buttonFBText={buttonFBText}
                            buttonGoogleText={buttonGoogleText}
                            asyncStrategy={asyncStrategy}
                            {...settings}
                        />
                    </div>
                );

                return [...memo, component];
            }

            return memo;
        },
        [],
    );

export default SocialLoginButtons;
